module.exports = __webpack_public_path__ + "img/right-circle.89054777.svg";